import React from 'react';
import classnames from 'classnames';
import { useDroppable } from '@dnd-kit/core';
import Show from 'components/Show';

const Droppable = ({ group, children }) => {
	const { setNodeRef } = useDroppable({
		id: group.order
	});

	const cls = classnames(
		'px-4 py-4 flex flex-col gap-2 transition-colors'
	);

	return (
		<div className="">
			<div className="px-4 py-3 text-base font-semibold text-neutral-700">
				{group.title}
			</div>

			<div ref={setNodeRef} className={cls}>
				{children}

				<Show if={!children.length}>
					<div className="py-4 px-4 border border-dashed border-neutral-200 dark:border-neutral-700 rounded-lg text-center text-neutral-600 dark:text-neutral-400 transition-colors">
						Ievelciet kursus šeit, lai to pievienotu mēneša plānam!
					</div>
				</Show>
			</div>
		</div>
	);
};

export default Droppable;